<template>
  <div>
    <b-row>
      <b-col md="12">
        <h3 class="mb-2">Partner Details</h3>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col md="3">
        <partner-nav :partner="partnerAllData"></partner-nav>
      </b-col>
      <b-col md="9">
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import partnerNav from "@/components/Partner/PartnerView/PartnerNav";

export default {
  name: "view-partner",
  components: {
    partnerNav,
  },
  computed: {
    ...mapGetters({
      partnerAllData: "partner/GetPartnerData",
    }),
  },
};
</script>
<style scoped></style>
